<template>
  <div>
    <em class="text-info" v-text="`Page: ${pagination.page}`" />
    <b-form-select
      class="w-auto ml-2"
      variant="primary"
      v-model="limit"
      :options="pagination.pageOptions"
    ></b-form-select>

    <b-button-group>
      <b-button
        variant="primary"
        class="mr-1"
        v-text="'<<'"
        :disabled="states.searching || pagination.page == 1"
        @click="setPage(1)"
      />
      <b-button
        variant="primary"
        class="mr-1"
        v-text="'<'"
        :disabled="states.searching || pagination.page == 1"
        @click="previousPage()"
      />
      <b-button
        variant="primary"
        class="mr-1"
        v-text="'>'"
        :disabled="
          states.searching || (items && items.length < pagination.limit)
        "
        @click="nextPage()"
      />
    </b-button-group>
  </div>
</template>

<script>

export default {
  computed: {
    states() {
      return this.$store.state.searchStore.states;
    },
    pagination() {
      return this.$store.state.searchStore.pagination;
    },
    items() {
      return this.$store.state.searchStore.items;
    },
    limit: {
      get() {
        return this.$store.state.searchStore.pagination.limit;
      },
      set(limit) {
        this.$store.commit("searchStore/setLimit", limit);
      },
    },
  },
  methods: {
    nextPage() {
      this.setPage(this.pagination.page + 1);
    },
    previousPage() {
      this.setPage(this.pagination.page - 1);
    },
    setPage(page) {
      this.$store.commit("searchStore/setPage", page);
    },
  },
}
</script>
